module.exports = __webpack_public_path__ + "static/media/wrestling.2875d375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/wrestling.jpg
// module id = 700
// module chunks = 0